module.exports = ".sidebar-title {\n    color: #062b3e;\n    font-size: 13px;\n    margin-bottom: 15px;\n    font-family: Montserrat-Bold;\n}\n.card-profile-wrapper{\n    min-height: 85vh;\n}\n.notification-item:hover {\n  background: #f0f0f0;\n  cursor: pointer;\n}\n.message-notification {\n  font-size: 13px;\n  margin-bottom: 0px;\n  background-color: #f5f6f7;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/main/roles-shared/components/push-notifications/push-notifications.component.css
// module id = ./src/app/feature/main/roles-shared/components/push-notifications/push-notifications.component.css
// module chunks = main